import React from 'react';

import Footer from '../components/Footer';
import '../App.css';

const VoyageRepairsAfloat = () => {
  return (
    <div>

      {/* Cover Section */}
      <div className="service-cover">
        <img
          src="/images/voyage.webp"
          alt="Voyage Repairs and Afloat Maintenance"
          className="service-cover-image"
        />
        <div className="service-cover-text">
          <h1>Voyage Repairs & Afloat Maintenance</h1>
          <p>Swift Onboard Solutions | Minimized Downtime | Global Support</p>
        </div>
      </div>

      {/* Main Content */}
      <section className="service-section container">
        <div className="intro-text">
          <h2>Keeping Your Fleet Moving Without Delay</h2>
          <p>
            At Blue Wave, we understand that downtime is costly. Our Voyage Repairs & Afloat Maintenance services
            are designed to ensure that your vessels remain operational while minimizing port stay or deviation.
          </p>
          <p>
            Whether you require emergency intervention or scheduled afloat maintenance, our mobile teams are
            equipped to deliver rapid, compliant, and high-quality solutions wherever your vessel is located.
          </p>
        </div>

        {/* Services Grid */}
        <div className="service-grid">
          <div className="service-card">
            <img src="/images/onboaring.webp" alt="Onboard Repairs" className="service-card-image" />
            <div className="service-card-content">
              <h3>Onboard Emergency Repairs</h3>
              <ul>
                <li>Structural welding and metalwork</li>
                <li>Pipe and valve replacement</li>
                <li>Engine and auxiliary equipment troubleshooting</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/aflot.webp" alt="Afloat Maintenance" className="service-card-image" />
            <div className="service-card-content">
              <h3>Afloat Maintenance Programs</h3>
              <ul>
                <li>Preventive maintenance without drydock</li>
                <li>Underwater inspections and hull cleaning</li>
                <li>Routine system calibration and testing</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/rapid.webp" alt="Global Coverage" className="service-card-image" />
            <div className="service-card-content">
              <h3>Global Rapid Response Teams</h3>
              <ul>
                <li>24/7 dispatch across major ports</li>
                <li>Certified engineers & technicians</li>
                <li>Compliant with Class & Flag regulations</li>
              </ul>
            </div>
          </div>

          <div className="service-card">
            <img src="/images/reporting.webp" alt="Reporting" className="service-card-image" />
            <div className="service-card-content">
              <h3>Technical Documentation & Reports</h3>
              <ul>
                <li>Post-repair inspection records</li>
                <li>Class reporting assistance</li>
                <li>Work summaries for transparency</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default VoyageRepairsAfloat;
